import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { lastValueFrom, retry, throwError, timer } from 'rxjs';
import { MatDialogModule } from '@angular/material/dialog';
import { SerialSearchComponent } from '../serial-search/serial-search.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InspectorDialogModel } from '../models/inspector-dialog.models';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { UrlBuilderService } from 'src/app/shared/services/url-builder.service';
import { TokenClaimsService } from 'src/app/shared/services/token-claims.service';
import { HttpErrorMessageService } from 'src/app/shared/services/http-error-message.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HbgSnackBar } from 'src/app/shared/toaster/hbg-toaster';
//potential fix for preview
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { QBuiltSharedInspService } from '../services/qbuilt-shared.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { formatDate } from '@angular/common';

@Component({
  selector: 'inspector-dialog',
  imports: [
    MatDialogModule,
    SerialSearchComponent,
    DropdownComponent,
    MatCheckboxModule,
    MatIcon,
    MatProgressSpinnerModule,
  ],
  templateUrl: './inspector-dialog.component.html',
  styleUrl: './inspector-dialog.component.scss',
})
export class InspectorDialogComponent implements OnDestroy {
  //dialog types
  // 1 = add new serial
  newSerialDialogTitle: string = this.qbuiltInspConstants.newSerialDialogTitle;
  newSerialInputTitle: string = this.qbuiltInspConstants.newSerialInputTitle;
  // 2 = photo attach
  photoAttachTitle: string = this.qbuiltInspConstants.attachPhotosTitle;
  optionalText: string = this.qbuiltInspConstants.optionalString;
  photoAttachMessage: string = this.qbuiltInspConstants.attachPhotosMessage;
  fileTypeMessage: string = this.qbuiltInspConstants.fileTypeMessage;
  photoLimitMessage: string = this.qbuiltInspConstants.limitMessage;
  photoMaxMessage: string = this.qbuiltInspConstants.maxMessage;
  addNewPhotoText: string = this.qbuiltInspConstants.addNewPhoto;
  uploadPhotoText: string = this.qbuiltInspConstants.uploadPhoto;
  saveBtnText: string = this.qbuiltInspConstants.saveButtonText;
  // 3 = add observed defect
  odDefectTitle: string = this.qbuiltInspConstants.odDialogTitle;
  odDefectMessage: string = this.qbuiltInspConstants.odDialogMessage;
  // 4 = final sign off
  finalSignOffTitle: string = this.qbuiltInspConstants.finalSignOffTitle;
  finalSignOffMessage: string = this.qbuiltInspConstants.finalSignOffMessage;
  finalSignOffPlaceholder: string =
    this.qbuiltInspConstants.finalSignOffPlaceholder;
  //5 = designate to station
  designateTitle: string = this.qbuiltInspConstants.designateTitle;
  selectedStation: any;
  availableStations: any[] = [];
  //6 - preview photo - specific to defect history
  photoDownload: any = '';
  private rawPreviewDataUrl: string | null = null;
  //7 - previewPdf
  pdfDialogTitle: string = this.qbuiltInspConstants.pdfDialogTitle;
  pdfDialogButton: string = this.qbuiltInspConstants.pdfDialogButton;
  pdfSerialNumberList: any[] = [];
  allSerials: boolean = false;
  sectionName?: string;
  @ViewChild('pdfContent') pdfContent!: ElementRef<HTMLDivElement>;
  pdfLoading: boolean = false;
  loadingPdfImgs: boolean = false;
  currentZoneName: string = '';
  currentSerial: string = '';
  locationLabel: string = this.qbuiltInspConstants.pdfLocationLabel;
  quantityLabel: string = this.qbuiltInspConstants.quantityLabel;
  descriptionLabel: string = this.qbuiltInspConstants.descriptionLabel;
  defectNameLabel: string = this.qbuiltInspConstants.defectNameLabel;
  deptLabel: string = this.qbuiltInspConstants.pdfDeptLabel;
  statusLabel: string = this.qbuiltInspConstants.pdfStatusLabel;
  imageLabel: string = this.qbuiltInspConstants.pdfImgLabel;

  //button Text
  cancelButtonText: string = this.qbuiltInspConstants.cancelButtonText;
  startButtonText: string = this.qbuiltInspConstants.startmButtonText;
  confirmButtonText: string = this.qbuiltInspConstants.confirmButtonText;
  sendButtonText: string = this.qbuiltInspConstants.sendText;

  dialogType: number;
  inputValue: string = '';
  validSerial: boolean = false;

  observedDefectList: any[] = [];
  selectedDefectTask: any;

  isSignatureGenerated: boolean = false;
  userName: string = '';
  userId: number;
  signature: string = '';
  currentDateTime: string = '';

  //additional Photo upload properties
  saveTrigger: boolean = false;
  photosAttached: boolean = false;
  selectedFile: File | null = null;
  attachedPhotos: any[] = [];
  photoError: boolean = false;
  endPointUrl: string = '';
  photoPreviewErrorMsg: string = this.qbuiltInspConstants.previewErrorMsg;
  photoErrorMsg: string = this.qbuiltInspConstants.photoErrorMsg;

  //session storage keys
  cqmsSessionKey: string = this.qbuiltInspConstants.cqmsItemsKey;
  cqmsDefectItemsKey: string = this.qbuiltInspConstants.defectItemsKey;

  //final photo list to send back from dialog
  finalPhotoList: any[] = [];
  //used to store the url paths of each photo
  photoUrlKeys: any[] = [];
  private uploadKeys = new WeakMap<File, string>();

  //photo preview properties
  previewUrl: SafeUrl | null = null;
  previewVisible: boolean = false;
  previewLoading: boolean = false;
  previewError: boolean = false;

  changesMade: boolean = false;

  //photo delete error properties
  deleteVisible: boolean = false;
  deleteError: boolean = false;
  deleteErrorMsg: string = '';

  @ViewChild('targetImage') imgElement!: ElementRef<HTMLImageElement>;

  constructor(
    private qbuiltInspConstants: QBuiltInspectorConstants,
    private http: HttpClient,
    private urlBuilder: UrlBuilderService,
    private tokenClaimService: TokenClaimsService,
    private httpErrorMessageService: HttpErrorMessageService,
    private toaster: HbgSnackBar,
    private sanitizer: DomSanitizer,
    private qbuiltSharedInspService: QBuiltSharedInspService,
    public dialogRef: MatDialogRef<InspectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: InspectorDialogModel,
  ) {
    const userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : null;
    dialogRef.disableClose = true;
    this.dialogType = dialogData.dialogType;
    this.observedDefectList = dialogData.dataList || [];
    this.userName = dialogData.userName || '';
    this.userId = userData?.UserId || 0;
    this.allSerials = dialogData.allSerials || false;
    this.sectionName = dialogData.sectionName;
  }

  ngOnInit() {
    //determine if there are photos already attached when modal is opened
    if (this.dialogType === 2) {
      let defect = this.dialogData.dataList || {};
      this.attachedPhotos = defect?.AttachmentLocationKeys || [];
      this.photosAttached = this.attachedPhotos.length > 0;
      if (this.photosAttached) {
        this.finalPhotoList = [...this.attachedPhotos];
      }
    }

    if(this.dialogType === 6) {
      const image = this.dialogData.previewImg;
      this.photoDownload = image;
      this.previewPhoto(image);
    }

    if(this.dialogType === 7) {
      const keys = this.dialogData.allSerials
        ? this.dialogData.dataList
            .flatMap((serial: any) => serial.sectionList ?? [])
            .flatMap((section: any) => section.Stations ?? [])
            .flatMap((station: any) => station.DefectedTasks ?? [])
            .flatMap((defect: any) => defect.AttachmentLocationKeys ?? null)
        : this.dialogData.dataList
            .flatMap((station: any) => station.DefectedTasks ?? [])
            .flatMap((defect: any) => defect.AttachmentLocationKeys ?? null);

      const uniqueKeys = [...new Set<string>(keys)];

      this.loadingPdfImgs = true;

      void Promise.all(uniqueKeys.map((key) => this.loadAttachment(key)))
        .finally(() => {
          this.loadingPdfImgs = false;
        });
      }

      this.currentZoneName = sessionStorage.getItem('cqmsSessionItems') ? JSON.parse(sessionStorage.getItem('cqmsSessionItems') || '{}').zoneName : '';
      this.currentSerial = sessionStorage.getItem('cqmsSessionItems') ? JSON.parse(sessionStorage.getItem('cqmsSessionItems') || '{}').activeSerial : '';
  }

  onSerialCheck(response: any) {
    if (response) {
      const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
        ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
        : {};
      cqmsSessionItems.selectedSerial = response.serialNumber;
      sessionStorage.setItem(
        this.cqmsSessionKey,
        JSON.stringify(cqmsSessionItems),
      );
      this.inputValue = response;
      this.validSerial = true;
    }
  }

  onDefectSelected(defectTask: string) {
    if (defectTask) {
      this.selectedDefectTask = defectTask;
      //add to defect list or section list or both ?
    }
  }

  generateSignature(event: MatCheckboxChange): void {
    this.isSignatureGenerated = event.checked;

    if (event.checked) {
      this.signature = this.userName;
      this.currentDateTime = new Date().toLocaleString();
    } else {
      this.signature = ''; // Clear signature when unchecked
    }
  }

  onConfirm() {
    if (this.dialogType === 1) {
      this.dialogRef.close(this.inputValue);
      const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
        ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
        : {};
      cqmsSessionItems.selectedSerial = '';
      sessionStorage.setItem(
        this.cqmsSessionKey,
        JSON.stringify(cqmsSessionItems),
      );
    } else if (this.dialogType === 3) {
      this.dialogRef.close(this.selectedDefectTask);
    } else if (this.dialogType === 4) {
      this.dialogRef.close(this.userId);
    } else if (this.dialogType === 5) {
      this.dialogRef.close(this.selectedStation);
    }
  }

  /***
   * Used for both Upload from Camera and Upload from Library
   * Supports single (camera) and multiple (library) file selection.
   * Each file is validated before being added to the attached photos list.
   */
  uploadPhoto(event: any) {
    const files: FileList = event.target.files;
    if (!files?.length) return;

    this.photoError = false;

    for (const file of Array.from(files)) {
      if (!this.validatePhoto(file)) {
        this.photoError = true;
        break;
      }

      this.attachedPhotos.push(file);
    }

    this.photosAttached = this.attachedPhotos.length > 0;
    this.selectedFile =
      this.attachedPhotos[this.attachedPhotos.length - 1] ?? null;
    this.changesMade = true;
  }

  //checks if the new photo meets the following requirements
  //file type: jpg, jpeg, png, heic?
  //file size limit: 5 MB
  //under 5 photos
  validatePhoto(file: File): boolean {
    if (!this.isValidPhotoFile(file) || this.attachedPhotos.length >= 5) {
      console.error(
        'Wrong file type, file type too large or you have reached the photo limit of 5 photos',
      );
      return false;
    } else {
      return true;
    }
  }

  nameValidation(photo: any) {
    if (typeof photo === 'string') {
      return photo.substring(photo.lastIndexOf('/') + 1);
    } else {
      return photo.name;
    }
  }

  //Button on modal to save photos to defect and api
  //will not be saved to DB until user clicks save progress or submits inspection
  async savePhoto() {
    this.saveTrigger = true;

    this.endPointUrl = this.urlBuilder.generateImageUploadUrl();
    const token = this.tokenClaimService.getIdToken();

    if (this.attachedPhotos.length === 0) {
      this.photosAttached = false;
      this.saveTrigger = false;
      this.dialogRef.close(this.finalPhotoList);
      return;
    }

    // Upload photos sequentially, one at a time
    for (const photo of [...this.attachedPhotos]) {
      //if statement to catch photos that have already been uploaded and were attached prior
      if (!photo.name) continue;

      const photoName = this.getUploadKey(photo);
      const params = new HttpParams().set('docId', photoName);

      try {
        const response = await lastValueFrom(
          this.http
            .post<any>(this.endPointUrl, photo, {
              params,
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': photo.type,
              },
            })
            .pipe(
              retry({
                count: 2,
                delay: (error: HttpErrorResponse, retryCount) =>
                  this.isTransientUploadError(error)
                    ? timer(retryCount * 500)
                    : throwError(() => error),
              }),
            ),
        );
        this.toaster.open(`Photo Uploaded Successfully`, '✕', {
          duration: 3000,
          panelClass: ['success-toast'],
        });
        this.finalPhotoList.push(response);
        const photoIndex = this.attachedPhotos.indexOf(photo);
        if (photoIndex > -1) {
          this.attachedPhotos[photoIndex] = response;
        }
      } catch (error: unknown) {
        this.saveTrigger = false;
        const failureTimestamp = new Date().toISOString();
        this.toaster.stickyError(
          `Unable to upload ${photo.name}. ${this.getUploadErrorMessage(error)} Timestamp: ${failureTimestamp}`,
        );
        return;
      }
    }

    // All new photos uploaded successfully.
    this.saveTrigger = false;
    this.dialogRef.close(this.finalPhotoList);
  }

  private getUploadKey(photo: File): string {
    const existingKey = this.uploadKeys.get(photo);
    if (existingKey) return existingKey;

    const extension = photo.name.substring(photo.name.lastIndexOf('.'));
    const uploadKey = `${crypto.randomUUID()}${extension}`;
    this.uploadKeys.set(photo, uploadKey);
    return uploadKey;
  }

  private isTransientUploadError(error: HttpErrorResponse): boolean {
    return error.status === 0 || error.status === 429 || error.status >= 500;
  }

  private getUploadErrorMessage(error: unknown): string {
    return this.httpErrorMessageService.format(error);
  }

  private isValidPhotoFile(file: File): boolean {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/heic', 'image/heif'];
    const maxSize = 5 * 1024 * 1024; // 5 MB

    return allowedTypes.includes(file.type) && file.size <= maxSize;
  }

  private updatePhotoErrorState(): void {
    this.photoError =
      this.attachedPhotos.length > 5 ||
      this.attachedPhotos.some(
        (photo) => photo instanceof File && !this.isValidPhotoFile(photo),
      );
  }

  //removes photo from list of possible uploads
  removePhoto(photo: any) {
    this.saveTrigger = true;

    //empty photo check
    if (photo.length === 0) {
      this.deleteVisible = true;
      this.deleteError = true;
      this.deleteErrorMsg = `Failed to delete ${photo.substring(photo.lastIndexOf('/') + 1) || 'photo'}. Please try again.`;
      this.saveTrigger = false;
    }

    if (photo instanceof File) {
      // Newly added file — remove from list
      const index = this.attachedPhotos.indexOf(photo);
      if (index > -1) {
        this.attachedPhotos.splice(index, 1);
        //remove the photo from the final photo list if it exists there
        let remove = this.finalPhotoList.filter((p) => p !== photo);
        this.finalPhotoList = remove;
      }
      if (this.attachedPhotos.length === 0) {
        this.photosAttached = false;
        this.selectedFile = null;
      }
      this.updatePhotoErrorState();
      this.saveTrigger = false;
      this.toaster.open(`Photo Deleted Successfully`, '✕', {
        duration: 3000,
        panelClass: ['success-toast'],
      });
    } else if (typeof photo === 'string') {
      // Previously attached S3 key — fetch from API
      const token = this.tokenClaimService.getIdToken();
      const baseUrl = this.urlBuilder.generateImageUploadUrl();
      this.http
        .delete(
          `${baseUrl}?docId=${photo.substring(photo.lastIndexOf('/') + 1)}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )
        .subscribe({
          next: () => {
            const index = this.attachedPhotos.indexOf(photo);
            if (index > -1) {
              this.attachedPhotos.splice(index, 1);
              //remove the photo from the final photo list if it exists there
              let remove = this.finalPhotoList.filter((p) => p !== photo);
              this.finalPhotoList = remove;
            }
            if (this.attachedPhotos.length === 0) {
              this.photosAttached = false;
              this.selectedFile = null;
            }
            this.updatePhotoErrorState();
            this.saveTrigger = false;
            this.toaster.open(`Photo Deleted Successfully`, '✕', {
              duration: 3000,
              panelClass: ['success-toast'],
            });
          },
          error: () => {
            this.deleteVisible = true;
            this.deleteError = true;
            this.deleteErrorMsg = `Failed to delete ${photo.substring(photo.lastIndexOf('/') + 1) || 'photo'}. Please try again.`;
            this.saveTrigger = false;
          },
        });
    }
    this.changesMade = true;
  }

  //allows user to preview photo before uploading by clicking on photo name
  previewPhoto(photo: any) {
    this.previewLoading = true;
    this.previewError = false;
    this.previewVisible = true;

    if (photo instanceof File) {
      // Newly added file — create local object URL
      const objectUrl = URL.createObjectURL(photo);
      this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      this.previewLoading = false;
    } else if (typeof photo === 'string') {
      // Previously attached S3 key — fetch from API
      const token = this.tokenClaimService.getIdToken();
      const baseUrl = this.urlBuilder.generateImageUploadUrl();
      this.http
        .get<string>(
          `${baseUrl}?docId=${photo.substring(photo.lastIndexOf('/') + 1)}`,
          {
            responseType: 'text' as 'json',
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .subscribe({
          next: (base64) => {
            const mimeType = base64.startsWith('/9j/')
              ? 'image/jpeg'
              : 'image/png';
            this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(
              `data:${mimeType};base64,${base64}`,
            );
            this.rawPreviewDataUrl = `data:${mimeType};base64,${base64}`;
            this.previewLoading = false;
          },
          error: (error) => {
            console.log('Failed to load photo preview', error);
            this.previewLoading = false;
            this.previewError = true;
          },
        });
    }
  }

  closePreview() {
    if (this.rawPreviewDataUrl?.startsWith('blob:')) {
      URL.revokeObjectURL(this.rawPreviewDataUrl);
    }

    this.rawPreviewDataUrl = null;
    this.previewUrl = null;
    this.previewVisible = false;
    this.previewError = false;

    //closes the dialog only if it is the preview for defect history
    if (this.dialogType === 6) {
      this.dialogRef.close(null);
      return;
    }
  }

  onPreviewImageError() {
    this.previewLoading = false;
    this.previewError = true;
  }

  ngOnDestroy() {}

  onCancel() {
    // Sign-off dialog (type 4) must close with null so the caller's !result guard fires
    // and the completion flow does not proceed on cancel.
    if (this.dialogType === 4) {
      this.dialogRef.close(null);
      return;
    }

    //remove type File from the attached photos list before closing the dialog
    this.attachedPhotos = this.attachedPhotos.filter(
      (photo) => !(photo instanceof File),
    );
    this.finalPhotoList = [...this.attachedPhotos];

    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
      ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
      : {};
    cqmsSessionItems.selectedSerial = '';
    sessionStorage.setItem(
      this.cqmsSessionKey,
      JSON.stringify(cqmsSessionItems),
    );
    this.dialogRef.close(this.finalPhotoList);
  }

  onStationSelected(station: any) {
    this.selectedStation = station;
  }

  //allows user to download image preview from the defect history component
  downloadImg() {
    if (!this.photoDownload) {
      return;
    }

    const fileName = this.nameValidation(this.photoDownload) || 'photo';
    const link = document.createElement('a');
    link.href = this.rawPreviewDataUrl || '';
    link.download = fileName;
    link.click();
   
  }

  //used from the sign off modal
  //formats data depending on whether or not the submission is single wide or not
  generatePdfForSignOff(dialogData: any) {
    if(dialogData.sectionName) {
      this.qbuiltSharedInspService.generatePdf(dialogData.dataList, false, dialogData.sectionName);
    } else {
      const stations = dialogData.dataList.flatMap((section: any) => section.Stations || []);
      this.qbuiltSharedInspService.generatePdf(stations, false);
    }
  }

  noDefectsForSignOff() {
    const data =
      JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
        .currentTabList || [];

    const hasDefectTasks = data.some((tab: any) =>
      tab.sectionList?.some((section: any) =>
        section.Stations?.some(
          (station: any) =>
            Array.isArray(station.DefectedTasks) &&
            station.DefectedTasks.length > 0,
        ),
      ),
    );

    if (!hasDefectTasks) {
      return true;
    }
    return false;
  }

  // resolves the task name from TaskExecutions since DefectedTasks only stores the TaskExecutionId
  getTaskExecutionName(station: any, taskExecutionId: number, taskName: string): string {
    if(taskName) {
      return taskName;
    } else {
      const execution = station.TaskExecutions?.find(
        (te: any) => te.Id === taskExecutionId,
      );
      return execution?.TaskName ?? '';
    }
  }

  attachmentUrls = new Map<string, string>();
  attachmentErrors = new Set<string>();

  private async loadAttachment(key: string): Promise<void> {
    try {
      const token = this.tokenClaimService.getIdToken();
      const baseUrl = this.urlBuilder.generateImageUploadUrl();
      const docId = encodeURIComponent(key.substring(key.lastIndexOf('/') + 1));

      const base64 = await lastValueFrom(
        this.http.get(`${baseUrl}?docId=${docId}`, {
          responseType: 'text',
          headers: { Authorization: `Bearer ${token}` },
        }),
      );

      const mimeType = base64.startsWith('/9j/')
        ? 'image/jpeg'
        : 'image/png';

      this.attachmentUrls.set(key, `data:${mimeType};base64,${base64}`);
    } catch {
      this.attachmentErrors.add(key);
    }
  }

  formatDefectDepartment(departmentId: number): string {
    const departments = JSON.parse(localStorage.getItem('departments') || '[]');
    return departments.find((department: any) => department.Id === departmentId)?.Name ?? '';
  }

  formatDefectLocation(locationId: number): string {
    const locations = JSON.parse(localStorage.getItem('locations') || '[]');
    return locations.find((location: any) => location.Id === locationId)?.Name ?? '';
  }

  formatDefectStatus(defect: any) {
    const statusList = [
      { id: 1, label: 'Open' },
      { id: 2, label: 'Sent to Station' },
      { id: 3, label: 'Fixed' },
      { id: 5, label: 'Designated' }
    ];

    const statusResult = statusList.find((s) => s.id === defect.StatusId)?.label ?? '';
    if(statusResult === 'Sent to Station') {
      return 'Sent to ' + defect.StationName;
    } else if(statusResult === 'Open') {
      return 'New';
    } else if(statusResult === 'Designated') {
      return 'Open Defect';
    } else {
      return statusResult;
    }
  }

  photoAttachCheck(attachmentLocationKeys: string[] | null): boolean {
    return attachmentLocationKeys !== null && attachmentLocationKeys.length > 0;
  }

  get pdfElementId(): string {
    return this.allSerials ? 'pdfContentAll' : 'pdfContent';
  }

  getPdfFileName(currentDateTime: Date = new Date()): string {
    const formattedDateTime = formatDate(
      currentDateTime,
      'MM/dd/yy_HH-mm-ss',
      'en-US',
    );

    if (this.allSerials) {
      return `${this.currentZoneName}-${formattedDateTime}.pdf`;
    }

    if (this.sectionName) {
      return `${this.currentZoneName}-${this.sectionName}-${this.currentSerial}-${formattedDateTime}.pdf`;
    }

    return `${this.currentZoneName}-${this.currentSerial}_${formattedDateTime}.pdf`;
  }

  //generates and opens pdf from preview
  onDownloadPdf(pdfContent: any) {
    const pdfWindow = window.open('', '_blank');
    if (pdfWindow) {
      const loadingDocument = pdfWindow.document;
      const style = loadingDocument.createElement('style');
      const status = loadingDocument.createElement('div');

      loadingDocument.title = 'Preparing PDF';
      style.textContent = `
        body { display: grid; min-height: 100vh; margin: 0; place-items: center; background: #f5f6f7; color: #292d32; font-family: sans-serif; }
        div { display: flex; align-items: center; gap: 12px; font-size: 18px; }
        div::before { width: 24px; height: 24px; content: ''; border: 3px solid #c7ccd1; border-top-color: #005eb8; border-radius: 50%; animation: spin 0.8s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
      `;
      status.textContent = 'Preparing PDF...';
      loadingDocument.head.append(style);
      loadingDocument.body.replaceChildren(status);
    }
    this.pdfLoading = true;

    // capture render the content in a plain offscreen wrapper, outside the dialog's
    // scrollable/flex-centered overlay layout, so nothing constrains or clips its height
    const original = pdfContent.nativeElement as HTMLElement;
    const clone = original.cloneNode(true) as HTMLElement;
    clone.style.maxHeight = 'none';
    clone.style.height = 'auto';
    clone.style.overflow = 'visible';

    const wrapper = document.createElement('div');
    wrapper.style.position = 'fixed';
    wrapper.style.top = '0';
    wrapper.style.left = '-99999px';
    wrapper.style.pointerEvents = 'none';
    wrapper.style.width = `${original.getBoundingClientRect().width}px`;
    wrapper.appendChild(clone);
    document.body.appendChild(wrapper);

    // clone's <img> nodes are freshly created and must (re)load, and fonts must finish
    // swapping in, before the final layout height is known - otherwise the last row(s)
    // can settle into place after html2canvas has already measured/captured the content
    this.waitForContentToSettle(clone).then(() => {
      const options = {
        scale: 1,
        useCORS: true,
        height: clone.scrollHeight,
        width: clone.scrollWidth,
        windowHeight: clone.scrollHeight,
        windowWidth: clone.scrollWidth,
      };
      const breakPoints = this.getPageBreakPoints(clone);

      return html2canvas(clone, options).then((canvas) => ({ canvas, breakPoints }));
    }).then(({ canvas, breakPoints }) => {
      const fileName = this.getPdfFileName();
      const pdf = this.buildMultiPagePdf(canvas, fileName, breakPoints);
      const pdfUrl = pdf.output('bloburl');

      if (pdfWindow) {
        pdfWindow.document.title = fileName;
        pdfWindow.location.replace(pdfUrl.toString());
      }
    }).catch(() => {
      pdfWindow?.close();
    }).finally(() => {
      wrapper.remove();
      this.pdfLoading = false;
    });
  }

  // top offsets (in clone-relative px) of each defect block, used so a page break never
  // lands in the middle of one, or between a defect and its preceding serial/section/
  // station headers - only ever between one defect group and the next
  private getPageBreakPoints(container: HTMLElement): number[] {
    const containerTop = container.getBoundingClientRect().top;
    const nodes = Array.from(
      container.querySelectorAll<HTMLElement>('.serial-number, .section-name, .station-name, .defect-container'),
    );

    const points: number[] = [];
    let pendingHeaderTop: number | null = null;

    for (const node of nodes) {
      const top = Math.round(node.getBoundingClientRect().top - containerTop);
      if (!node.classList.contains('defect-container')) {
        pendingHeaderTop ??= top;
        continue;
      }

      points.push(pendingHeaderTop ?? top);
      pendingHeaderTop = null;
    }

    points.push(container.scrollHeight);
    return Array.from(new Set(points)).sort((a, b) => a - b);
  }

  // picks the furthest safe break point that still fits within one page, falling back
  // to a hard cut only when a single block is itself taller than a page
  private getSliceEnd(renderedHeight: number, maxPageHeight: number, totalHeight: number, breakPoints: number[]): number {
    const limit = Math.min(renderedHeight + maxPageHeight, totalHeight);
    const safeBreak = breakPoints.filter((point) => point > renderedHeight && point <= limit).pop();
    return safeBreak ?? limit;
  }

  // splits a tall canvas across fixed US-letter pages, breaking only between defect
  // blocks - a page may end with blank space below a break, but every page is the
  // same standard size and no image is ever split mid-page
  private buildMultiPagePdf(canvas: HTMLCanvasElement, fileName: string, breakPoints: number[]): jsPDF {
    const pageWidthPt = 612; // US letter: 8.5in x 72pt/in
    const pageHeightPt = 792; // US letter: 11in x 72pt/in
    const marginPt = 24;
    const contentWidthPt = pageWidthPt - marginPt * 2;
    const contentHeightPt = pageHeightPt - marginPt * 2;

    const scale = contentWidthPt / canvas.width;
    const maxSliceHeight = contentHeightPt / scale;

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: [pageWidthPt, pageHeightPt],
    });
    pdf.setProperties({ title: fileName });

    const pageCanvas = document.createElement('canvas');
    pageCanvas.width = canvas.width;
    const pageContext = pageCanvas.getContext('2d');

    let renderedHeight = 0;
    let isFirstPage = true;

    while (renderedHeight < canvas.height && pageContext) {
      const sliceEnd = this.getSliceEnd(renderedHeight, maxSliceHeight, canvas.height, breakPoints);
      const sliceHeight = sliceEnd - renderedHeight;
      pageCanvas.height = sliceHeight;
      pageContext.clearRect(0, 0, canvas.width, sliceHeight);
      pageContext.drawImage(canvas, 0, renderedHeight, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight);

      const sliceData = pageCanvas.toDataURL('image/jpeg', 0.9);
      if (!isFirstPage) {
        pdf.addPage([pageWidthPt, pageHeightPt]);
      }
      pdf.addImage(sliceData, 'JPEG', marginPt, marginPt, contentWidthPt, sliceHeight * scale, undefined, 'FAST');

      renderedHeight = sliceEnd;
      isFirstPage = false;
    }

    return pdf;
  }

  private waitForContentToSettle(container: HTMLElement): Promise<void> {
    // guard against a stuck font/image load hanging PDF generation indefinitely
    const timeout = new Promise<void>((resolve) => setTimeout(resolve, 3000));
    const ready = this.waitForImagesToLoad(container)
      .then(() => (document as { fonts?: { ready: Promise<unknown> } }).fonts?.ready ?? Promise.resolve())
      .then(() => new Promise<void>((resolve) => requestAnimationFrame(() => requestAnimationFrame(() => resolve()))));

    return Promise.race([ready, timeout]);
  }

  private waitForImagesToLoad(container: HTMLElement): Promise<void> {
    const images = Array.from(container.querySelectorAll('img'));
    return Promise.all(
      images.map((img) =>
        img.complete && img.naturalWidth > 0
          ? Promise.resolve()
          : new Promise<void>((resolve) => {
              img.addEventListener('load', () => resolve(), { once: true });
              img.addEventListener('error', () => resolve(), { once: true });
            }),
      ),
    ).then((): void => undefined);
  }
}
